/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type HTMLAttributes, createContext, forwardRef } from 'react';
import { type ContextValue, useContextProps } from 'react-aria-components';
import { Skeleton } from '../skeleton/skeleton.component';

interface ChatSkeletonProps extends Omit<HTMLAttributes<HTMLDivElement>, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const ChatSkeletonContext = createContext<ContextValue<ChatSkeletonProps, HTMLDivElement>>({});

const ChatSkeleton = forwardRef((props: ChatSkeletonProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, ChatSkeletonContext);

  const { style, ...coreProps } = props;

  return (
    <div ref={ref} {...stylex.props(styles.base, style)} {...coreProps}>
      <SentGroup />
      <ReceivedGroup />
      <SentGroup />
      <ReceivedGroup />
    </div>
  );
});

function SentGroup() {
  return (
    <div {...stylex.props(styles.sentGroup)}>
      <Skeleton style={styles.tallBubble} />
      <Skeleton style={styles.shortBubbleSent} />
    </div>
  );
}

function ReceivedGroup() {
  return (
    <div {...stylex.props(styles.receivedGroup)}>
      <Skeleton style={styles.avatarSkeleton} />
      <div {...stylex.props(styles.bubbleColumn)}>
        <Skeleton style={styles.tallBubbleReceived} />
        <Skeleton style={styles.shortBubbleReceived} />
      </div>
    </div>
  );
}

const styles = stylex.create({
  avatarSkeleton: {
    borderRadius: 999,
    flexShrink: 0,
    height: 32,
    width: 32,
  },
  base: {
    gap: 16,
    marginBlock: 8,
    paddingInline: 17,
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  bubbleColumn: {
    flex: '1',
    gap: 2,
    display: 'flex',
    flexDirection: 'column',
  },
  receivedGroup: {
    gap: 10,
    alignItems: 'flex-end',
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'row',
  },
  sentGroup: {
    gap: 2,
    alignItems: 'flex-end',
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 60,
  },
  shortBubbleReceived: {
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '12px',
    height: 36,
    width: 160,
  },
  shortBubbleSent: {
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '4px',
    height: 36,
    width: 160,
  },
  tallBubble: {
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '4px',
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
    height: 56,
  },
  tallBubbleReceived: {
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '12px',
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
    height: 56,
  },
});

export { ChatSkeleton, ChatSkeletonContext, type ChatSkeletonProps };
